import BadgeCheckIcon from '@/assets/badge-check.svg?react';
import EnvelopeOpenIcon from '@/assets/envelope-open.svg?react';
import ChatMessage from '@/components/ChatMessage';
import { CONSULTANTS } from '@/features/v2/consultants';

import { type EcommerceFormValues } from '../schema';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

const StepDone = () => {
  const { i18n } = useLingui();
  const { watch } = useFormContext<EcommerceFormValues>();
  const email = watch('billing_email');

  return (
    <>
      <ChatMessage
        variant="primary"
        className="pb-0"
        consultant={CONSULTANTS.KASIA_ASSISTANT}
        description={i18n.t('Gotowe — zamówienie zostało przyjęte.')}
        hideCloseButton
      />

      <div className="flex flex-col gap-3 rounded-xlg bg-white p-[14px] md:gap-5 md:p-6">
        <div className="flex items-center gap-3">
          <BadgeCheckIcon className="size-8 shrink-0 text-primary" />
          <p className="h3 text-primary">{i18n.t('Dziękujemy za zakup!')}</p>
        </div>

        <div className="flex flex-col gap-3 rounded-md bg-gray-200 p-[14px] md:p-6">
          <div className="flex items-center gap-2">
            <EnvelopeOpenIcon width={16} className="shrink-0 text-primary" />
            <p className="h5 text-dark-gray-500">
              {i18n.t('Potwierdzenie wysłaliśmy na adres:')}
            </p>
          </div>

          <div className="rounded-md bg-white p-3 text-center">
            <p className="body-semi text-dark-gray-500">{email}</p>
          </div>

          <p className="caption-large text-dark-gray-500">
            {i18n.t(
              'Dokument PDF wyślemy na ten adres e-mail. Jeśli dodano konsultację z prawnikiem, skontaktujemy się z Tobą, żeby ustalić termin.'
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default StepDone;
